
export class ContadorsDto {



	public packetCount: number;
	public palletCount: number;
	public kilosCount: number;
	public litresCount: number;
	public productCount: number;
	public quantityProduct: number;
	public shipmentCount: number;

	public showCounts: boolean;
	public showPalletCountOnRouteCard: boolean;
	public showKilosCountOnRouteCard: boolean;
	public showLitresCountOnRouteCard: boolean;
	public showQuantityProductOnRouteCard: boolean;
	public showPacketCountOnRouteCard: boolean;
	public showProductCountOnRouteCard: boolean;
	public showShipmentCountOnRouteCard: boolean;
}